export const LOGIN_STEPS = {
  phone: "phone",
  code: "code",
} as const;

export const SMS_RETRY_TIMEOUT_SEC = 60;
